import { InfiniteData } from "@tanstack/react-query";

interface Edge<T> {
  node: T
}
interface Connection<T> {
  edges?: Array<Edge<T>> | undefined
}

export function mapEdgesToItems<T>(
  data?: Connection<T> | undefined
): T[] | undefined {
  return data?.edges?.map(({ node }) => node)
}
export function flattenInfiniteData<T>(data: InfiniteData<T> | undefined): T[] {
  // If data is undefined, return an empty array
  if (!data) return [];

  // Combine all pages into a single array
  return data.pages.reduce((acc, page) => {
    acc.push(page);
    return acc;
  }, [] as T[]);
}
